import {Component, OnInit} from '@angular/core';
import {RatefileTspExtService} from 'src/app/services/ratefile-tsp-ext/ratefile-tsp-ext.service';
import {UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';
import {AlertService} from 'src/app/services/alert/alert.service';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {Carrier, FrtRatesBidcycles} from 'src/app/shared/common-components/common-structure';
import {RatesTspExt} from '../ratefile-tsp-ext/rates-tsp-ext';

@Component({
    selector: 'app-frt-ratefile-tsp-ext',
    templateUrl: './frt-ratefile-tsp-ext.component.html',
    styleUrls: ['./frt-ratefile-tsp-ext.component.css'],
    standalone: false
})
export class FrtRatefileTspExtComponent implements OnInit {
  typeaheadlist: string[];
  businessType: any;
  carrierList: Carrier[];
  scacCodeList: string[] = [];
  disabled = true;
  minLengthToSearch: Number;
  maxCharLength: Number;
  frtRateFileTspExtForm: UntypedFormGroup;
  currentBidcycles: FrtRatesBidcycles[];
  ratesTspExt: RatesTspExt;
  bidCloseMinDate: any;

  disableSaveBtn: boolean;
  updateSuccessful: boolean;
  updateFailure: boolean;
  errorMessage: string;

  bidcycleChange: boolean;
  bidcloseChange: boolean;

  oRatesBidcyclesId: number;
  oCarrierId: number;
  oBidWindowCloseDate: Date;
  oAdditionalInformation: string;

  allRateTspExt: RatesTspExt[];
  itemsPerPage = 10;

  rateTspExtColumnDefs = [
    {headerName: 'SCAC', field: 'scac', width: 100},
    {headerName: 'SCAC Name', field: 'scacName', width: 250},
    {headerName: 'Bidcycle Name', field: 'rateBidcyclesName', width: 200},
    {
      headerName: 'Extended Close Date', field: 'expiryDate', width: 170, filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }
    },
    {headerName: 'Email Address', field: 'updateEmail', width: 250},
    {headerName: 'Additional Info', field: 'additionalInformation', width: 257}
  ];
  domLayout;

  constructor(private ratefileTspExtService: RatefileTspExtService,
              private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private tmssLoader: LoadingService
  ) {
  }

  ngOnInit() {
    this.domLayout = 'autoHeight';
    this.disableSaveBtn = true;
    this.getCurrentBidcycles('FRT');
    //this.getcarrierList("FRT");
    this.getRatesTspExt('FRT');
    this.initValues();
    this.createForm();
  }

  /*
  * Get all the carriers based on the Business Type for the Type head
  */

  getcarrierList(rateBidcycleId: any) {
    this.tmssLoader.show();
    this.ratefileTspExtService.getCarriersListByParticipation(rateBidcycleId)
      .subscribe(carrierRecords => {
        this.carrierList = carrierRecords;
        if (this.carrierList.length > 0) {
          for (const carrierOutput of carrierRecords) {
            this.scacCodeList.push(carrierOutput.scac);
            this.minLengthToSearch = 1;
            this.maxCharLength = 4;
            this.typeaheadlist = this.scacCodeList;
            this.tmssLoader.hide();
          }
        } else {
          this.errorMessage = 'There are no particpants for this bidcycle';
          this.updateFailure = true;
          this.disableSaveBtn = true;
          this.tmssLoader.hide();
        }
      });
  }

  getCurrentBidcycles(businessType: string) {
    this.ratefileTspExtService.getCurrentBidcycles(businessType)
      .subscribe(currentBidcycles => {
        this.currentBidcycles = currentBidcycles;
      });
  }

  getRatesTspExt(businessType: string) {
    this.ratefileTspExtService.getRatesTspExtByBusinessType(businessType)
      .subscribe(allRateTspExt => {
        this.allRateTspExt = allRateTspExt;
      });
  }

  createForm() {
    this.frtRateFileTspExtForm = this.fb.group({
      openBidcycles: new UntypedFormControl('', [Validators.required]),
      carrierKeyword: new UntypedFormControl('', [Validators.required]),
      bidOpenDate: new UntypedFormControl('', [Validators.required]),
      bidCloseDate: new UntypedFormControl('', [Validators.required]),
      carrierName: new UntypedFormControl('', [Validators.required]),
      addlText: new UntypedFormControl('', [Validators.required])
    });
  }

  initValues() {
    this.updateFailure = false;
    this.updateSuccessful = false;
    this.errorMessage = '';
    this.bidcycleChange = false;
    this.bidcloseChange = false;
  }

  onBidcyclesChange(ratesBidcyclesId: any) {
    this.oRatesBidcyclesId = ratesBidcyclesId;
    this.getcarrierList(ratesBidcyclesId);
    this.errorMessage = '';
    this.updateFailure = false;
    this.bidcycleChange = true;
    this.disableSaveBtn = false;
    for (let bidcyle of this.currentBidcycles) {
      if (bidcyle.ratesBidcyclesId == ratesBidcyclesId) {
        this.frtRateFileTspExtForm.get('bidOpenDate').setValue(bidcyle.bidWindowOpenDate);
        this.frtRateFileTspExtForm.get('bidCloseDate').setValue(bidcyle.bidWindowCloseDate);
        let dateString = bidcyle.bidWindowCloseDate;
        this.bidCloseMinDate = new Date(dateString);
      }
    }
  }

  onScacSelect(scac: any) {
    for (let carrier of this.carrierList) {
      if (carrier.scac === scac) {
        this.frtRateFileTspExtForm.get('carrierName').setValue(carrier.scacName);
        this.oCarrierId = carrier.carrierId;
      }
    }

  }

  onAddlText(addlText: any) {
    this.oAdditionalInformation = addlText;
  }

  bidCloseDateChange(bidCloseDate: any) {
    this.oBidWindowCloseDate = bidCloseDate;
  }

  saveRateExtRec() {
    if (!this.bidcycleChange) {
      this.errorMessage = 'Please select a bidcycle';
      this.updateFailure = true;
      this.disableSaveBtn = true;
      return;
    }
    if (this.frtRateFileTspExtForm.get('carrierKeyword').value === '') {
      this.errorMessage = 'Please select a scac';
      this.updateFailure = true;
      return;
    }

    this.ratesTspExt = new RatesTspExt();
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    for (let carrier of this.carrierList) {
      if (carrier.scac === this.frtRateFileTspExtForm.get('carrierKeyword').value) {
        this.oCarrierId = carrier.carrierId;
      }
    }

    this.ratesTspExt.carrierId = this.oCarrierId;
    this.ratesTspExt.ratesBidcyclesId = this.oRatesBidcyclesId;
    this.ratesTspExt.expiryDate = this.oBidWindowCloseDate;
    this.ratesTspExt.additionalInformation = this.oAdditionalInformation;
    this.ratesTspExt.rateEffectiveDate = today;
    this.ratesTspExt.rateExpiryDate = today;
    this.ratesTspExt.rateReleaseDate = today;
    this.ratesTspExt.updateDate = today;
    this.ratesTspExt.updateId = 0;
    this.ratesTspExt.updateProgram = '';
    this.ratesTspExt.scac = '';
    this.ratesTspExt.scacName = '';
    this.ratesTspExt.updateEmail = '';
    this.ratesTspExt.rateBidcyclesName = '';

    this.tmssLoader.show();
    this.ratefileTspExtService.createRatesTspExt(this.ratesTspExt)
      .subscribe(data => {
        this.alertService.success('Your carrier extension has been successfully updated.');
        this.tmssLoader.hide();
        this.getRatesTspExt('FRT');
        this.updateSuccessful = true;
        this.updateFailure = false;
        this.disableSaveBtn = true;

      }, error => {
        console.log('Error in creating the record', error);
        this.updateFailure = true;
        this.updateSuccessful = false;
        this.errorMessage = 'Please Select a new bid window close date';
        this.tmssLoader.hide();
      });
  }

  clearPage() {
    this.frtRateFileTspExtForm.get('openBidcycles').setValue('');
    this.frtRateFileTspExtForm.get('carrierKeyword').setValue('');
    this.frtRateFileTspExtForm.get('bidOpenDate').setValue('');
    this.frtRateFileTspExtForm.get('bidCloseDate').setValue('');
    this.frtRateFileTspExtForm.get('carrierName').setValue('');
    this.frtRateFileTspExtForm.get('addlText').setValue('');
    this.errorMessage = '';
    this.disableSaveBtn = false;
    this.updateFailure = false;
    this.updateSuccessful = false;
    this.bidcycleChange = false;
    this.bidcloseChange = false;
  }
}

